<template>
  <div>
    <v-toolbar flat color="primary" dark>
      <v-toolbar-title>Assessments Report</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-progress-linear
      slot="progress"
      color="primary"
      height="4"
      indeterminate
      v-show="progressBar"
    ></v-progress-linear>

    <v-card class="elevation-1">
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container fluid>
            <v-layout row wrap>
              <v-flex xs12 sm6 md6>
                <v-select
                  v-model="batchId"
                  :items="batches"
                  item-text="Name"
                  name="Batch"
                  label="Batch"
                  id="Batch"
                  required
                  v-on:change="getBatchAssessmentReport"
                  item-value="Id"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>

    <v-card v-show="isBatchAssessmentReport">
      <v-container fluid grid-list-md>
        <v-layout wrap>
          <v-flex xs12>
            <v-data-table
              :headers="headers"
              :items="studentsProgress"
              :pagination.sync="pagination"
              :loading="progressBar"
              item-key="Id"
              class="elevation-1"
              select-all
              :rows-per-page-items="rowsPerPageItems"
            >
              <template v-slot:progress>
                <v-progress-linear
                  slot="progress"
                  color="primary"
                  height="4"
                  indeterminate
                ></v-progress-linear>
              </template>
              <template v-slot:headers="props">
                <tr>
                  <th
                    v-for="header in props.headers"
                    :key="header.text"
                    :class="[
                      'column sortable',
                      pagination.descending ? 'desc' : 'asc',
                      header.value === pagination.sortBy ? 'active' : ''
                    ]"
                    @click="changeSort(header.value)"
                  >
                    <v-icon small>arrow_upward</v-icon>
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <tr>
                  <td class="text-xs-center">
                    {{ passedStudents[props.index].FirstName }}
                  </td>
                  <td class="text-xs-center">
                    {{ passedStudents[props.index].LastName }}
                  </td>
                  <td
                    v-for="(value, index) in tableDisplayFields"
                    :key="index"
                    class="text-xs-center"
                  >
                    {{ props.item[value] }}
                  </td>
                </tr>
              </template>
              <template v-slot:footer>
                <tr>
                  <td :colspan="headers.length">
                    Average Batch Pass Percentage = {{ passPercentage }}%
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import dbStore from "../db/dbStore";
import Utils from "../utils";
import { mapMutations, mapGetters } from "vuex";

export default {
  created() {
    if (!this.$store.getters.get_login) {
      this.$router.push({
        path: "/signin"
      });
    }
    this.getData();
  },
  data() {
    return {
      valid: false,
      studentId: "",
      batchId: "",
      progressBar: false,
      model: null,
      rowsPerPageItems: [10, 20, 30, 40],
      pagination: {
        sortBy: "name",
        rowsPerPage: 30
      },
      headers: [
        {
          text: "First Name",
          align: "center",
          sortable: true,
          value: "FirstName"
        },
        { text: "Last Name", value: "LastName", align: "center" },
        { text: "Tests Taken", value: "TestsTaken", align: "center" },
        { text: "Percentage", value: "score", align: "center" },
        { text: "Status", value: "passed", align: "center" }
      ],
      tableDisplayFields: [
        "TestsTaken",
        "score",
        "passed"
      ],
      isBatchAssessmentReport: false,
      students: [],
      passedStudents: [],
      allStudents: [],
      batches: [],
      studentsProgress: [],
      allStudentProgresses: [],
      batchStudents: [],
      batchStudentsProgress: [],
      models: [],
      passPercentage: ""
    };
  },
  computed: {
    login_details: function() {
      return this.$store.getters.get_login_details;
    }
  },

  methods: {
    getBatchAssessmentReport(id) {

      //console.log(id);
      this.studentsProgress = [];
      this.progressBar = true;
      this.passedStudents = [];
      
      this.students = this.allStudents.filter(item => {
        return item.Batch == id;
      });

/*       this.studentProgresses = this.allStudentProgresses.filter(item => {
        console.log(item);
        return item.id == id;
      }); */

/*       this.model = Utils.getItemFromListWithId(this.batches, id);
      this.batchStudents = Utils.getObjectsOfIds(
        this.model.Students,
        this.students
      ); */
      //console.log(this.students);
/*       this.batchStudentsProgress = Utils.getObjectsOfIds(
        this.model.Students,
        this.studentProgresses
      ); */
      //console.log(this.allStudentProgresses);
/*       this.models = Utils.mergeObjects(
        this.students,
        this.studentProgresses
      ); */

      var testTakenCount = 0;
      var totalPercentage = 0;
      this.students.forEach(prog => {
        this.allStudentProgresses.forEach(element => {
          if (element.id === prog.Id) {
            this.studentsProgress.push(element);
            this.passedStudents.push(prog);
            if (element.tests_taken) {
              var test = element.tests_taken[0];
              element.passed = test.passed ? "Passed" : "Failed";
              element.score = test.score;
              element.TestsTaken = 1;
              testTakenCount++;
              totalPercentage = totalPercentage + test.score;
            } else {
              element.passed = "N/A";
              element.score = "N/A";
              element.TestsTaken = 0;
            }
          }
        })
      });
      // TODO Round off the percent to 2 digits only
      this.passPercentage = totalPercentage / testTakenCount;
      this.isBatchAssessmentReport = true;
      this.progressBar = false;
    },

    async getData() {
      this.progressBar = true;
      dbStore.setCollectionName("students");
      this.allStudents = await dbStore.getItems();
      dbStore.setCollectionName("studentprogress");
      this.allStudentProgresses = await dbStore.getItems();
      dbStore.setCollectionName("batches");
      this.batches = await dbStore.getItems();
      var filter = { Field: "Status", Operator: "!=", Value: "Closed" };
      this.batches = this.filterItems(this.batches, filter);
      this.batches = await this.getBatchesForCurrentCenter(this.batches)
      this.progressBar = false;
    },

    filterItems(items, filter) {
      var temp = [];
      items.forEach(element => {
        if (element[filter.Field]) {
          var statement =
            '"' +
            element[filter.Field] +
            '"' +
            filter.Operator +
            '"' +
            filter.Value +
            '"';
          if (eval(statement)) {
            temp.push(element);
          }
        } else {
          temp.push(element);
        }
      });
      return temp;
    },

    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    async getBatchesForCurrentCenter(batches) {
      var temp = []
      var centerId = this.login_details.centerId
      batches.forEach(batch => {
        if(centerId == 0 || batch.CenterId === centerId) {
          temp.push(batch)
        }
      });
      return temp
    },

    ...mapMutations([
      "_login_details"
    ])
  }
};
</script>

<style scoped></style>
